import { render, staticRenderFns } from "./AnnouncementDetailPage.vue?vue&type=template&id=0a4925b9&scoped=true"
import script from "./AnnouncementDetailPage.vue?vue&type=script&lang=js"
export * from "./AnnouncementDetailPage.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementDetailPage.vue?vue&type=style&index=0&id=0a4925b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4925b9",
  null
  
)

export default component.exports